import Form from '../../form';
import addServices from '../../addServices';
import Vue from "vue";

let app = new Vue({
    el: '#app-vipbooking',

    mounted: function () {
        let vm = this;

        $("#app-vipbooking").on('focusout', function (event) {
            let elemName = event.target.getAttribute('name');
            let elemType = event.target.getAttribute('type');
            if (event.target.classList.contains('error')) {
                event.target.classList.remove('error');
                vm.form.errors.clear(elemName);
            }
            if (elemType == 'text' || event.target.tagName.toLowerCase() == 'textarea') {
                console.log(elemName);
                if (elemName != 'email' && (typeof app.form[elemName] !== 'undefined')) {
                    app.form[elemName] = app.form[elemName].toUpperCase();
                }
            }
            if(event.target.classList.contains('needcheck')) {
                var i = app.needcheck.indexOf(elemName);
                if(i > -1) {
                    app.needcheck.splice(i,1);
                }

            }
        });
    },

    data: {
        form: new Form({
            id: '',
            uid: '',
            airport: '',
            payservice: 'no',
            payAt: 'amex',
            name: '',
            RM: '',
            nation: 'DE',
            position: 'CENTURION',
            seat: '',
            bc:'',
            phone: '',
            bookingcode: '',
            amexbookingcode:'',
            tmexception: false,
            pspnumber:'',
            pspinfo:'',
            paxe: '1',
            flightdata: '',
            traveltype: '',
            transitdata: '',
            servicedate: '',
            viptime: '',
            time: '',
            date: '',
            tradate: '',
            finaldest: '',
            dsInfo: false,
            remark: '',
            remarkC: '',
            remarks: '',
            carReg: '',
            amexValetService: false,
            clientarrivingby: 'nocar',
            baggage: '',
            additionalServices: '',
            state: ''
        }),
        saved: false,
        blocked: false,
        submitting: false,
        flightDataChecked: false,
        editable: true,
        inPast: false,
        showStorno: false,
        inStornoTime: true,
        inServiceTime: true,
        preServiceTime: 'ok',
        isLongstay: false,
        isTraMinTimeOk: true,
        counter: [],
        mg: 0,
        priceAMG: '',
        priceADT: '',
        lateBookingAccepted: false,
        alertAccepted: false,
        needcheck: [],
        RMs:[],
        cloptions: [{'val': '', 'text': window.translations.please_select[window.locale]},{'val': 'nocar', 'text': window.translations.no_car[window.locale]}, {'val': 'vps', 'text': window.translations.vps[window.locale]}, {'val': 'crv', 'text': window.translations.crv[window.locale]}],
        bcoptions: [{'val': 'ECONOMY', 'text': 'Economy'},{'val': 'P_ECONOMY', 'text': 'Premium Economy'}, {'val': 'BUSINESS', 'text': 'Business'}, {'val': 'FIRST', 'text': 'First'}],
        pspinfooptions: window.translations.psp_info_options[window.locale],
        crvAvailable: true,
        vpsAvailable: true,
        prices: '',
    },
    computed: {
        flightdata() {
            return this.form.flightdata;
        },
        transitdata() {
            return this.form.transitdata;
        },
        viptime() {
            return this.form.viptime;
        },
        servicedate() {
            return this.form.servicedate;
        },
        paxe() {
            return this.form.paxe;
        },
        amexbookingcode() {
            return this.form.amexbookingcode;
        },
        submitEnabled() {
            return this.flightDataChecked && !this.blocked;
        },
        additionalServicesCount() {
            if(this.form.additionalServices == '') {
                return 0;
            }
            return JSON.parse(this.form.additionalServices).length;
        }
    },
    watch: {
        flightdata() {
            this.flightDataChecked = false;
            if(this.form.flightdata != this.form.originalData.flightdata) {
                this.alertAccepted = false;
                if(_.indexOf(this.needcheck, 'flightdata') === -1) {
                    this.needcheck.push('flightdata');

                }
            }
        },
        transitdata() {
            this.flightDataChecked = false;
            if(this.form.transitdata != this.form.originalData.transitdata) {
                if(_.indexOf(this.needcheck,'transitdata') === -1) {
                    this.needcheck.push('transitdata');
                }
            }
        },
        submitting() {
            if (this.submitting) {
                $("#overlay").show();
            } else {
                $("#overlay").hide();
            }
        },
        viptime() {
            this.flightDataChecked = false;
        },
        servicedate() {
            console.log('servicedate changed');
            this.checkPayService();
        },
        amexbookingcode() {
            if(this.form.amexbookingcode!=null && this.form.amexbookingcode!='') {
                this.form.tmexception = false;
                this.form.pspinfo = '';
                this.form.pspnumber = '';
            }
        },
        paxe(newpax, oldpax) {
            console.log('paxe');

            for(var i = 1; i < this.form.paxe; i++) {
                if(_.isUndefined(this.form['additionalTraveller'+i])) {
                    this.$set(this.form, 'additionalTraveller'+i, '');
                    this.$set(this.form, 'bcAdditionalTraveller'+i, this.form.bookingcode);
                    this.$set(this.form, 'positionAdditionalTraveller'+i, 'CENTURION');
                    this.$set(this.form, 'nationAdditionalTraveller'+i, this.form.nation);
                }
            }
            if(oldpax > newpax) {
                for(var i = this.form.paxe; i < oldpax; i++) {
                    delete(this.form['additionalTraveller'+i]);
                    delete(this.form['bcAdditionalTraveller'+i]);
                    delete(this.form['positionAdditionalTraveller'+i]);
                    delete(this.form['nationAdditionalTraveller'+i]);
                    delete(this.form['seatAdditionalTraveller'+i]);
                }
            }
        },
    },

    components: {},

    methods: {
        init(appdata) {
            this.form.init(appdata.formdata);
            this.counter = appdata.counter;
            this.mg = appdata.mg;
            this.priceADT = appdata.priceADT;
            this.priceAMG = appdata.priceAMG;
            this.editable = appdata.editable;
            this.showStorno = appdata.showStorno;
            this.inPast = appdata.inPast;
            this.inServiceTime = appdata.inServiceTime;
            this.preServiceTime = appdata.preServiceTime;
            this.flightDataChecked = appdata.flightDataChecked;
            this.RMs = appdata.RMs;
            this.needcheck = ['flightdata'];
            this.crvAvailable = appdata.crvAvailable;
            this.vpsAvailable = appdata.vpsAvailable;
            this.prices = appdata.prices;
            this.prebooking = appdata.prebooking;
            //if we have created a vps we cannot create crv and vv
            if(this.form.state != 'open' && this.form.state != 'storno') {
                if(this.form.vpsbooking) {
                    this.cloptions = _.reject(this.cloptions, function(e) {return e.val === 'crv'});
                }
                if(this.form.crvbooking) {
                    this.cloptions = _.reject(this.cloptions, function(e) {return e.val === 'vps'});
                }

            }
            if(this.form.airport === "FRA" && typeof  this.prebooking !== 'undefined' && this.prebooking !== null && this.prebooking !== '') {
                swal.fire({
                    text: 'Vorausbuchungsfrist am Airport Frankfurt '+(this.prebooking??'')+' Stunden',
                    type:'info'
                })
            }

        },
        needCheck(name) {

            if(_.indexOf(this.needcheck, name)!==-1) {
                console.log('needcheck');
                return 'needcheck';
            } else {
                return '';
            }
        },
        onSubmit(event) {
            console.log('onsubmit');
            this.form.errors.clear();
            this.submitting = true;
            this.calcDates(event, 'submit');
        },
        submit() {
            console.log('submit');
            this.form.post(document.getElementById('vipbookingform').getAttribute('action'))
                .then(response => {
                    if (response.hasOwnProperty('message')) {
                        swal({
                            type: 'error',
                            title: window.translations.save_error_title[window.locale],
                            text: window.translations.save_error_text[window.locale],
                            confirmButtonText: window.translations.proceed[window.locale],
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        });
                        this.submitting = false;
                        return false;
                    }
                    this.saved = true;
                    console.log(response.bookingId);
                    swal({
                        type: 'success',
                        title: window.translations.save_success_title[window.locale],
                        text: window.translations.save_success_text[window.locale],
                        confirmButtonText: window.translations.proceed[window.locale],
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        location.href = response.nextUrl;
                    })
                }).catch(
                error => {
                    swal({
                        type: 'error',
                        title: window.translations.order_error_title[window.locale],
                        text: window.translations.order_error_text[window.locale],
                        confirmButtonText: window.translations.ok[window.locale],
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        this.saved = false;
                        this.submitting = false;
                    })

                }
            )
        },
        storno(url) {
            console.log('storno');
            axios.post('/checkFreeStorno', {service: 'vip', booking: this.form.id}).then((response => {
                console.log(response);
                if (response.data.storno == 'pay') {
                    swal({
                        type: 'warning',
                        title: window.translations.storno1_title[window.locale],
                        text: window.translations.storno1_text[window.locale],
                        confirmButtonText: window.translations.storno[window.locale],
                        showCancelButton: true,
                        cancelButtonText: window.translations.cancel[window.locale],
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        if (result.value) {
                            this.doStorno(url);
                        } else {
                            return;
                        }
                    })
                } else {
                    swal({
                        type: 'question',
                        title: window.translations.storno_title[window.locale],
                        text: window.translations.storno_text[window.locale],
                        confirmButtonText: window.translations.storno[window.locale],
                        showCancelButton: true,
                        cancelButtonText: window.translations.cancel[window.locale],
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        if (result.value) {
                            this.doStorno(url);
                        } else {
                            return;
                        }
                    })

                }

            }));

        },
        doStorno(url) {
            this.submitting = true;
            this.form.post(url)
                .then(response => {
                    this.saved = true;
                    swal({
                        type: 'success',
                        title: window.translations.storno_success_title[window.locale],
                        text: window.translations.storno_success_text[window.locale],
                        confirmButtonText: window.translations.storno[window.locale],
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        location.href = response.nextUrl;
                    })
                })
                .catch(
                    error => {
                        console.log(error);
                        this.submitting = false;
                    }
                )
        },
        gotoSend(url) {
            location.href = url;
        },
        showRemarks(event) {
            swal({
                title: window.translations.remark[window.locale],
                html: this.form.remarks
            })
        },
        showAddServices(event) {
            console.log(event);
            let addS = new addServices();
            addS.showModal(this.form.airport, 'vip', this.form.additionalServices, app);
        },
        showPrices(event) {
            console.log(this.prices);
            swal({
                title: window.translations.prices_title[window.locale],
                html: this.prices,
                confirmButtonText: window.translations.ok[window.locale],
                allowOutsideClick: true,
                allowEscapeKey: true,
            }).then((result) => {
                return;
            })
        },
        checkPayService() {
            if(this.form.originalData.payservice !== 'yes') {
                //check if service must be payed
                axios.post('/vipservice/checkpayservice', {id: this.form.id, uid: this.form.uid, airport: this.form.airport, date: this.form.servicedate}).then((response) => {
                    if (response.data.payservice === 'yes' || response.data.payservice === 'no') {
                        this.form.payservice = response.data.payservice;
                    }
                });
            }
        },
        calcDates(event, successMethod) {
            this.form.flightdata = this.form.sanitizeValue(this.form.flightdata);
            this.form.transitdata = this.form.sanitizeValue(this.form.transitdata);
            if (this.flightDataChecked) {
                if (!(typeof successMethod == 'undefined')) {
                    this[successMethod]();
                }
                return;
            }
            this.flightDataChecked = true;
            console.log('calcdates');
            this.form.errors.clear('flightdata');
            this.form.errors.clear('transitdata');
            axios.post('/vipservice/checkAndCalculateDatesAndType', {
                airport: this.form.airport,
                flightdata: this.form.flightdata,
                transitdata: this.form.transitdata,
                viptime: this.form.viptime
            })
                .then(response => {
                    console.log(response.data);
                    if(response.data.alert !== '' && response.data.alert.indexOf('blocking') !== -1) {
                        this.blocked = true;
                    } else {
                        this.blocked = false;
                    }
                    if (response.data) {
                        this.form.traveltype = response.data.type;
                        this.$set(this.form, 'servicedate', response.data.servicedate);
                        this.$set(this.form, 'time', response.data.time);
                        this.$set(this.form, 'date', response.data.date);
                        this.$set(this.form, 'tradate', response.data.tradate);
                        this.inServiceTime = response.data.inServiceTime;
                        this.preServiceTime = response.data.preServiceTime;
                        this.isLongstay = response.data.isLongstay;
                        this.isTraMinTimeOk = response.data.isTraMinTimeOk;

                        if ((response.data.lateBooking && !this.lateBookingAccepted) && (response.data.alert !== '' && !this.alertAccepted)) {
                            swal({
                                type: 'warning',
                                title: window.translations.important_notice[window.locale],
                                html: '<div class="alert alert-warning">'+window.translations.prebookingtime_too_short[window.locale]+'</div>'+response.data.alert
                            }).then((result) => {
                                this.lateBookingAccepted = true;
                                this.alertAccepted = true;
                            })
                        }
                        else if (response.data.alert !== '' && !this.alertAccepted) {
                            swal({
                                type: 'warning',
                                title: window.translations.important_notice[window.locale],
                                html: response.data.alert
                            }).then((result) => {
                                this.alertAccepted = true;
                            })
                        }
                        else if (response.data.lateBooking && !this.lateBookingAccepted) {
                            swal({
                                type: 'warning',
                                title: window.translations.prebookingtime[window.locale],
                                text: window.translations.prebookingtime_too_short[window.locale]
                            }).then((result) => {
                                this.lateBookingAccepted = true;
                            })
                        }
                        if(this.form.originalData.payservice !== 'yes') {
                            //check if service must be payed
                            axios.post('/vipservice/checkpayservice', {id: this.form.id, uid: this.form.uid, airport: this.form.airport, date: this.form.servicedate}).then((response) => {
                                if (response.data.payservice === 'yes' || response.data.payservice === 'no') {
                                    this.form.payservice = response.data.payservice;
                                }
                            });
                        }
                        console.log(successMethod);
                        if (!(typeof successMethod == 'undefined')) {
                            console.log(successMethod);
                            this[successMethod]();
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.flightDataChecked = false;
                    this.form.onFail(error.response.data);

                });

        }


    }
});


export default app;